import qs from "qs";
import moment_ from 'moment';
const moment = moment_;

/**
 * @author kai8wz
 * @date 2019-03
 * @licensor Robert Bosch GmbH, 2018
 * @version 1.0.0
 *
 * @jsdoc request
 * @name api.requests:GetDuePaymentsRequest
 * @description
 * Due payments request holding API query parameters.
 * Currently follows PT OData interface
 * See: https://inside-docupedia.bosch.com/confluence/display/PBP/PTB2B+SAP+Sync+Financial+Data+Integration+-+Open+Instalments
 */
export class GetDuePaymentsRequest {
  pageSize: number = null;
  offset: number = null;
  invoice: string = null;
  entryType: string = null;
  dueDateFrom: Date = null;
  dueDate: Date = null;
  amount: number = null;
  quantity: number = null;
  status: string = null;
  multiAccount: boolean = false;
  customerIds: string = null;
  cnpjOrUid: string = null;
  emailAddress: string = null;

  /**
   * @jsdoc method
   * @name constructor
   * @methodOf api.requests:GetDuePaymentsRequest
   * @description description
   * Sets request query default parameters.
   */
  constructor(startDate?, endDate?, numberOfRecords?, entryType?, status?, multiAccount?) {
    this.dueDateFrom = startDate ? new Date(startDate) : null;
    this.dueDate = endDate ? new Date(endDate) : null;
    this.pageSize = numberOfRecords;
    this.entryType = entryType;
    this.status = status;
    this.multiAccount = multiAccount;
  }


  /**
   * @jsdoc method
   * @name setQueryParam
   * @methodOf api.requests:GetDuePaymentsRequest
   * @description description
   * Sets request query parameter. Allows only parameters that are class atributes
   */
  setQueryParam(name, value) {
    if (this.hasOwnProperty(name)) {
      this[name] = value === '' ? null : value;
    }
  }

  resetUniqueParams() {
    this.invoice = null;
    this.amount = null;
  }

  /**
   * @jsdoc method
   * @name toQueryString
   * @methodOf api.requests:GetDuePaymentsRequest
   * @description description
   * Builds query string from class atributes.
   * Uses qs for query string and moment.js for date formatting according to interface requirements
   */
  toQueryString() {
    return qs.stringify(this, {
      addQueryPrefix: true,
      skipNulls: true,
      sort: null,
      serializeDate: (d) => { return moment(d).format('DDMMYYYY'); }
    });
  }
}
